import {
    useApi,
    Toaster,
    CustomBackdrop,
    CustomButton,
    AddProjectCategory,
    AddProjectSubCategory,
    ProjectSubCategory,
    CustomDataGrid,
    SubCategory,
    Category,
    DeleteIcon,
    Box
} from '../../../utils/globalImports';

import {
    React,
    useState,
    useEffect,
    GridColDef,
    Typography,
    Tooltip,
    EditCalendarIcon,
    AddCommentIcon,
    IconButton,
    Grid2,
    useParams
} from '../../../utils/globalImports';

import { ApiResponse } from '../../../services/apiService';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const ProjectCategory: React.FC = () => {

    const { execute, loading } = useApi();
    // State to manage the modal visibility
    const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
    const [isSubCategoryModalOpen, setIsSubCategoryModalOpen] = useState(false);
    const [isSubCategoryViewModalOpen, setIsSubCategoryViewModalOpen] = useState(false);
    const [category, setCategory] = useState<any[]>([]);
    const [toast, setToast] = useState({ open: false, message: "", type: "success" });
    const [selectedCategory, setSelectedCategory] = useState<any | null>(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState<any | null>(null);
    const [dialogOpen, setDialogOpen] = useState(false);  // State to manage confirm dialog "open/close" state

    const { projectId } = useParams();
    const userId = Number(localStorage.getItem("userId"));

    useEffect(() => {
        fetchCategories();
    }, []);  // The empty dependency array ensures it only runs once when the component mounts

    // Fetch categories
    const fetchCategories = async () => {
        const { data } = await execute<Category[]>('get', `/Category/Project/${projectId}`);
        if (data) {
            setCategory(data);
        }
    };

    const columns: GridColDef<(typeof category)[number]>[] = [
        {
            field: 'description', headerName: 'Category Name', flex: 1, headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'notes', headerName: 'Description', flex: 3, headerAlign: 'center',
            align: 'center',
        },
        // {
        //     field: 'status', headerName: 'Status', flex: 1, headerAlign: 'center',
        //     align: 'center',
        // },
        {
            field: 'actions', headerName: 'Action', flex: 1, headerAlign: 'center',
            align: 'center',
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, width: '100%' }}>
                    <Tooltip title="Edit Category">
                        <IconButton
                            color="primary"
                            aria-label="edit"
                            onClick={() => {
                                setSelectedCategory(params.row); // Set the category to edit
                                setIsCategoryModalOpen(true);
                            }}
                        >
                            <EditCalendarIcon sx={{
                                color: '#a3c63d',
                                border: '2px solid #bce348',
                                p: 0.3,
                                borderRadius: "20%",
                                height: "30px",
                                width: "30px",
                            }} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Add Subcategory">
                        <IconButton color="primary" aria-label="edit"
                            onClick={() => {
                                setSelectedCategory(params.row)
                                setIsSubCategoryModalOpen(true)
                            }}
                        >
                            <AddCommentIcon sx={{
                                color: '#a3c63d',
                                border: '2px solid #bce348',
                                p: 0.5,
                                borderRadius: "20%",
                                height: "30px",
                                width: "30px",
                            }} ></AddCommentIcon>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="View Subcategory">
                        <IconButton color="primary" aria-label="edit"
                            onClick={() => {
                                setSelectedCategory(params.row)
                                setIsSubCategoryViewModalOpen(true);
                            }}
                        >
                            <RemoveRedEyeIcon sx={{
                                color: '#a3c63d',
                                border: '2px solid #bce348',
                                p: 0.3,
                                borderRadius: "20%",
                                height: "30px",
                                width: "30px",
                            }} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Delete">
                        <IconButton
                            color="primary"
                            aria-label="edit"
                            onClick={() => {
                                setSelectedCategory(params.row);
                                setDialogOpen(true);
                            }}
                        >
                            <DeleteIcon sx={{
                                color: '#a3c63d',
                                border: '2px solid #bce348',
                                p: 0.3,
                                borderRadius: "20%",
                                height: "30px",
                                width: "30px",
                            }} >

                            </DeleteIcon>
                        </IconButton>
                    </Tooltip>
                </div>
            ),
        },
    ];

    const handleSubmit = async (formData: any) => {
        let response: ApiResponse<any> = { data: null, error: null };

        if (selectedCategory) {
            const updatedCategoryData = {
                projectId: Number(projectId),
                id: selectedCategory.id,
                description: formData.description,
                notes: formData.notes,
                isActive: formData.status === 'Active' ? true : false, // Update based on Status
                updatedId: userId,
            };

            response = await execute('put', `/Category/${selectedCategory.id}`, updatedCategoryData);
        } else {

            // Adding a new category
            const category: Category = {
                projectId: Number(projectId),
                description: formData.description,
                notes: formData.notes,
                isActive: formData.status === 'Active' ? true : false,
                createdid: userId,
            };

            response = await execute('post', '/Category', category);
        }

        if (response!) {
            if (response.error) {
                // If there's an error in the response, display the error message
                setToast({ open: true, message: response.error, type: "error" });
            } else {
                // If the response is successful, display the success message
                setToast({ open: true, message: response.data, type: "success" });
                handleClose()
                fetchCategories();  // Awaiting the API call
            }
        }
    };

    const handleDialogConfirm = async () => {
        if (!selectedCategory) return;

        try {

            let response: ApiResponse<any> = await execute('delete', `/Category/${selectedCategory.id}`);

            if (response!) {
                if (response.error) {
                    // If there's an error in the response, display the error message
                    setToast({ open: true, message: response.error, type: "error" });
                } else {
                    // If the response is successful, display the success message
                    setToast({ open: true, message: response.data, type: "success" });
                }
            }
            fetchCategories();
            setSelectedCategory(null); // Clear selected row
        }

        catch (error) {
            console.error('Error updating status:', error);
        } finally {
            setDialogOpen(false);
        }
    };

    const handleClose = () => {
        setSelectedCategory(null); // Reset category when modal closes
        setSelectedSubCategory(null) // Reset sub-category when modal closes
        setIsCategoryModalOpen(false);
        setIsSubCategoryModalOpen(false);
        setIsSubCategoryViewModalOpen(false);
    }

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
                <Grid2 container spacing={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    <Grid2 sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography noWrap sx={{ color: '#1e66ab', fontWeight: 500, mb: 2, fontSize: 24 }}>
                            Fee Stage Category
                            <Typography variant="body2" sx={{ color: "#6b7280" }}>
                                Manage fee stage category for this project.
                            </Typography>
                        </Typography>
                    </Grid2>

                    {/* Add Button */}
                    <Grid2 size={{ xs: 12, md: 6, lg: 2 }} sx={{ mt: 0 }}>
                        <CustomButton
                            capsule
                            sx={{
                                mt: -1,
                                mb: 2,
                                textTransform: 'none',
                                whiteSpace: 'nowrap',
                                p: 0
                            }}
                            onClick={() => setIsCategoryModalOpen(true)}
                        >
                            <Typography variant="body2" sx={{ fontSize: 30, color: '#fff', display: 'flex', alignItems: 'center', gap: 1, mr: 1 }}>
                                +
                            </Typography>
                            Add Category
                        </CustomButton>
                    </Grid2>
                </Grid2>

                <Box sx={{display: "flex", flexDirection: "column", minHeight: "auto", maxHeight:'400px'}}>
                {/* Grid */}
                <CustomDataGrid
                    customMessage='There are no categories to display.'
                    rows={category}
                    columns={columns}
                    isDialogOpen={dialogOpen}
                    actionName={'Category'}
                    handleCancel={() => {
                        setSelectedCategory(null); // Reset selectedUser when modal closes
                        setDialogOpen(false);
                    }}
                    handleConfirm={handleDialogConfirm}
                >
                </CustomDataGrid>
                </Box>
            </Box>
            {/* Category Modal */}
            {isCategoryModalOpen && (
                <AddProjectCategory
                    open={isCategoryModalOpen}
                    onClose={handleClose}
                    onSubmit={handleSubmit}
                    categoryData={selectedCategory}
                >
                </AddProjectCategory>
            )}


            {/* SubCategory Modal */}
            {isSubCategoryModalOpen && (
                <AddProjectSubCategory
                    open={isSubCategoryModalOpen}
                    onClose={handleClose}
                    categoryData={selectedCategory}
                    subCategoryData={selectedSubCategory}
                >
                </AddProjectSubCategory>
            )}

            {/* View SubCategory Modal */}
            {isSubCategoryViewModalOpen && (
                <ProjectSubCategory open={isSubCategoryViewModalOpen}
                    onClose={handleClose}
                    categoryData={selectedCategory}
                    onRowEdit={(row: SubCategory) => {
                        setSelectedSubCategory(row)
                        setIsSubCategoryModalOpen(true)
                        setIsSubCategoryViewModalOpen(false);
                    }}
                >
                </ProjectSubCategory>
            )}

            {/* Loader */}
            <CustomBackdrop open={loading} />

            {/* Toaster */}
            <Toaster
                open={toast.open}
                message={toast.message}
                type={toast.type as "success" | "error"}
                onClose={() =>
                    setToast({ ...toast, open: false })
                }
            />

        </>
    );
};

export default ProjectCategory;